import * as React from "react";

export const GeneralLoader = (props) => {
  return (
    <div className="ajax-progress ajax-progress-throbber"><div className="throbber"></div></div>
  );
};